export default "__VITE_ASSET__C6xDP6un__"